export default "__VITE_ASSET__NxsKXHyJ__"